// export const BASE_URL = "http://127.0.0.1:8001/api/v1"
export const BASE_URL = "https://hrb.bnpz.uz/api/v1"
